var messageCtrl = {

	message : '',
	messageType: '',

	listeners: [],

	setMessage(message,messageType) {
		messageCtrl.messageType = messageType;
		messageCtrl.message = message;
		messageCtrl.emit();
	},

	clearMessage(){
		messageCtrl.setMessage('','');
	},

	setErrorMessage(message){
		messageCtrl.setMessage(message,'danger');
	},

	addListener(callback){
		if (messageCtrl.listeners.indexOf(callback) == -1) messageCtrl.listeners.push(callback);
	},

	removeListener(callback){
		messageCtrl.listeners = messageCtrl.listeners.filter(function(c1){
			return c1 != callback;
		});
	},

	emit(){
		messageCtrl.listeners.map(function(callback){
			callback();
		});
	},

	mixin: {
		componentDidMount(){
			messageCtrl.addListener(this.refreshMessage);
		},
		componentWillUnmount(){
			messageCtrl.removeListener(this.refreshMessage);
		},
		refreshMessage(){
			this.setState({});
		}
	}
}

module.exports = messageCtrl;


/** WEBPACK FOOTER **
 ** ./src/utils/message-controller.js
 **/